(function(){
  'use strict';
  function initRelatedProducts(){
    document.querySelectorAll('[data-related-products]').forEach(function(el){
      var url = el.getAttribute('data-url');
      if(!url) return;
      fetch(url).then(function(r){ return r.text(); }).then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-related-grid]');
        var grid = el.querySelector('[data-related-grid]');
        if(newGrid && grid){
          grid.innerHTML = newGrid.innerHTML;
          if(!newGrid.innerHTML.trim()){ el.style.display = 'none'; }
        } else if(grid && !grid.innerHTML.trim()){
          el.style.display = 'none';
        }
        el.querySelectorAll('[data-animate]').forEach(function(e){ e.classList.add('is-visible'); });
        if(window.BTInitImageFade) window.BTInitImageFade(el);
      }).catch(function(){});
    });
  }
  document.addEventListener('DOMContentLoaded', initRelatedProducts);
})();
